module.exports = "https://coursera_assets.s3.amazonaws.com/images/5a3e9b48cd8b6fecc39cd5e013358c19.svg";